/**
 * Pluggable token-refresh strategy.
 *
 * The axios 401 interceptor calls the registered refresher to obtain a fresh
 * session before retrying the failed request. The web app uses the default
 * refresher (a cookie-based `POST /auth/refresh-token`). The desktop shell
 * has no cookies on its main window, so it registers its own refresher that
 * silently re-runs the WorkOS login popup to mint a new bearer token.
 *
 * A refresher resolves when the session has been renewed and rejects when it
 * could not be — the interceptor treats a rejection as "session expired".
 */
export type TokenRefresher = () => Promise<void>

let refresher: TokenRefresher | null = null

export function setTokenRefresher(fn: TokenRefresher): void {
  refresher = fn
}

export function getTokenRefresher(): TokenRefresher | null {
  return refresher
}
